import channel from './modules/channel';
import merchants from './modules/merchants';
import rules from './modules/rules';
export default {
  channel,
  merchants,
  rules
};
